import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { StyledFooter, ApplyButton } from './Styles';

const propTypes = {
  applyFilter: PropTypes.func.isRequired,
  testId: PropTypes.string
};

const defaultProps = {
  testId: undefined
};

const Footer = ({ applyFilter, testId }) => {
  return (
    <StyledFooter>
      <ApplyButton onClick={applyFilter} testId={testId}>
        <FormattedMessage id="list.filters.apply" />
      </ApplyButton>
    </StyledFooter>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
